 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"d00fdc626a70ccf4a987da623d171ea35532214e","3":"5886a555008141f7f3b550ad45271dce1bcdb4d9","4":"9057285d8ce720cd65e658ca2ba8cbc41789711e","5":"f6d09afbdddd7073050d65fb249b23c0102b45f1","6":"14388aae7d7b7d36974318d7264951b3e8a9a429","10":"29107295","13":"component---src-pages-404-tsx","14":"component---src-pages-abonnieren-tsx","15":"component---src-pages-agb-tsx","16":"component---src-pages-anmelden-tsx","17":"component---src-pages-autoren-tsx","18":"component---src-pages-autorenvereinbarung-tsx","19":"component---src-pages-codes-tsx","20":"component---src-pages-datenschutz-tsx","21":"component---src-pages-edition-makroskop-tsx","22":"component---src-pages-freiexemplar-tsx","23":"component---src-pages-gespraechskreise-tsx","24":"component---src-pages-guide-tsx","25":"component---src-pages-impressum-tsx","26":"component---src-pages-jobs-tsx","27":"component---src-pages-kontakt-tsx","28":"component---src-pages-leserbriefe-tsx","29":"component---src-pages-lesezeichen-tsx","30":"component---src-pages-makronaut-tsx","31":"component---src-pages-newsletter-tsx","32":"component---src-pages-passwort-vergessen-tsx","33":"component---src-pages-registrieren-tsx","34":"component---src-pages-themenhefte-tsx","35":"component---src-pages-ueber-uns-tsx","36":"component---src-pages-webshop-tsx","37":"component---src-pages-weihnachten-tsx","38":"component---src-templates-all-articles-tsx","39":"component---src-templates-all-editions-tsx","40":"component---src-templates-all-spotlights-tsx","41":"component---src-templates-article-tsx","42":"component---src-templates-event-tsx","43":"component---src-templates-home-page-tsx","44":"component---src-templates-magazine-tsx","45":"component---src-templates-podcasts-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"011f66be77c2d359f5d1","2":"84076cd26a2d2ed66fe4","3":"d9587efaf77b58a47484","4":"dc88db26f59b78421a5e","5":"a13784e8fcbe7adff9a5","6":"42bb90e61de19aa7c385","8":"50dd6324efc5782a9bf4","10":"0861cbcfd498d7c95912","13":"fe1833fa8dba4494540d","14":"6a87ed18e945b630e528","15":"da7ce84ce3749883859a","16":"76d1d6f02611219ea611","17":"c9cb817911a3e669ba35","18":"0fa235f36eea6a017402","19":"4b301e36b74fa6b10496","20":"118cc0b19c2251e38895","21":"3bb5a9236df2320f4809","22":"48f0ec5a629bfdf88c9b","23":"72355939aee219b6d994","24":"f5584435784ea2b028a0","25":"c9c610936c4d9d8f0041","26":"f13bae5417153fd12f00","27":"9f87018d5ba581fc60b0","28":"b29c468ff5f0001e6824","29":"9a08be78d5594864cb98","30":"bd2d6c36017f9321b20f","31":"13bf38295ab169010eb0","32":"00b4525ca85c1019e014","33":"322e66c9375cded0f1f1","34":"f27cebebf2c1de359d33","35":"ada73601c34923eb3f0f","36":"c2eb7ec5cf8179f9100c","37":"bffdbf69f25dfc4171c3","38":"8769a8c4493b1021fa02","39":"b38b905429522702d256","40":"121be29e355aa486a23a","41":"9cf2093d61741566d1f2","42":"f0143eed3fe38078cd3d","43":"db99be45a5752a7a7f52","44":"a6b4b36735c9d21c12aa","45":"c6c58ced75d7328b1e22","48":"8f4cdcceca9495ed7050","49":"5e95cf802714a19f4b41"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"d00fdc626a70ccf4a987da623d171ea35532214e","3":"5886a555008141f7f3b550ad45271dce1bcdb4d9","4":"9057285d8ce720cd65e658ca2ba8cbc41789711e","5":"f6d09afbdddd7073050d65fb249b23c0102b45f1","6":"14388aae7d7b7d36974318d7264951b3e8a9a429","10":"29107295","13":"component---src-pages-404-tsx","14":"component---src-pages-abonnieren-tsx","15":"component---src-pages-agb-tsx","16":"component---src-pages-anmelden-tsx","17":"component---src-pages-autoren-tsx","18":"component---src-pages-autorenvereinbarung-tsx","19":"component---src-pages-codes-tsx","20":"component---src-pages-datenschutz-tsx","21":"component---src-pages-edition-makroskop-tsx","22":"component---src-pages-freiexemplar-tsx","23":"component---src-pages-gespraechskreise-tsx","24":"component---src-pages-guide-tsx","25":"component---src-pages-impressum-tsx","26":"component---src-pages-jobs-tsx","27":"component---src-pages-kontakt-tsx","28":"component---src-pages-leserbriefe-tsx","29":"component---src-pages-lesezeichen-tsx","30":"component---src-pages-makronaut-tsx","31":"component---src-pages-newsletter-tsx","32":"component---src-pages-passwort-vergessen-tsx","33":"component---src-pages-registrieren-tsx","34":"component---src-pages-themenhefte-tsx","35":"component---src-pages-ueber-uns-tsx","36":"component---src-pages-webshop-tsx","37":"component---src-pages-weihnachten-tsx","38":"component---src-templates-all-articles-tsx","39":"component---src-templates-all-editions-tsx","40":"component---src-templates-all-spotlights-tsx","41":"component---src-templates-article-tsx","42":"component---src-templates-event-tsx","43":"component---src-templates-home-page-tsx","44":"component---src-templates-magazine-tsx","45":"component---src-templates-podcasts-tsx"}[chunkId]||chunkId) + "." + {"0":"c8813f9a8a943f5456f7","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
